<script setup lang="ts">
import { $dayjs } from '@/utils/dayjs'
import { formatShortPeriod } from '@/utils/date'

const { locale } = useI18n()
const { data } = useSearchInput()
</script>

<template>
  <button type="button" class="w-full">
    <div
      class="flex h-[48px] items-center justify-between rounded border border-gray-200 bg-gray-100 px-3 py-3.5"
    >
      <div class="flex w-1/2 text-sm">
        <BaseIcon name="pinAlt" class="mr-1 flex-none" />
        <span class="truncate pt-0.5 font-semibold">
          {{ data.location.name || $t('search.destination') }}
        </span>
      </div>

      <div class="flex items-center">
        <div class="max-w-[88px] truncate text-sm">
          <template v-if="data.startDate && data.endDate">
            {{
              formatShortPeriod(
                [
                  $dayjs(data.startDate).format('YYYY-MM-DD'),
                  $dayjs(data.endDate).format('YYYY-MM-DD'),
                ],
                locale,
              )
            }}
          </template>
          <template v-else>Dates</template>
        </div>
        <span class="mx-2 block h-3 border-r border-gray-700" />
        <div
          :class="[
            'max-w-[65px] truncate text-sm xs:max-w-[70px]',
            { ' lowercase': data.guest },
          ]"
        >
          {{ $t('search.capacity', { count: data.guest }) }}
        </div>
      </div>
    </div>
  </button>
</template>
